export enum enumUserTypes {
  Overview = "Overview",
  PlayerStatistics = "Player Statistics",
  KycDocuments = "KYC Documents",
  Tags = "Tags",
  Affiliate = "Affiliate",
  RiskFraud = "Risk & Fraud"
  // Transactions = "Transactions",
  // Bonuses = "Bonuses",
  // FinancialDetails = "Financial Details",
  // Referals = "Referals",
  // ActivityLogs = "Activity Logs"
}
